var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDialogButton',{attrs:{"width":"450","disabled":_vm.disabled,"buttonText":_vm.i18n.t('_InviteUser'),"buttonIcon":"mdi-account-plus","title":_vm.i18n.t('_InviteUser'),"actions":[
    {
      color: 'primary',
      buttonText: _vm.i18n.t('_InviteUser'),
      method: this.confirm
    }
  ]},on:{"cancel":_vm.cancel}},[_c('template',{slot:"content"},[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":_vm.i18n.t('_Username') + ' *',"rules":_vm.usernameRules,"data-cy":"tf-username"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }